import { CommonModule, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxCurrencyDirective, NgxCurrencyInputMode, provideEnvironmentNgxCurrency } from 'ngx-currency';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AgenciaModule } from './componentes/agencia/agencia.module';
import { AgendaItemComponent } from './componentes/agenda/agenda-item/agenda-item.component';
import { CampanhaModule } from './componentes/campanha/campanha.module';
import { CancelamentoComponent } from './componentes/cancelamento/cancelamento.component';
import { CupomModule } from './componentes/cupom/cupom.module';
import { DialogoComponent } from './componentes/dialogo/dialogo/dialogo.component';
import { FooterComponent } from './componentes/footer/footer.component';
import { HomeModule } from './componentes/home/home.module';
import { IapComponent } from './componentes/iap/iap.component';
import { LogDetailComponent } from './componentes/log/log-detail/log-detail.component';
import { LogComponent } from './componentes/log/log.component';
import { LoginModule } from './componentes/login/login.module';
import { NavBarComponent } from './componentes/nav-bar/nav-bar.component';
import { ParametrosComponent } from './componentes/parametros/parametros.component';
import { SideNavComponent } from './componentes/side-nav/side-nav.component';
import { TempoMedioDetalhadoComponent } from './componentes/tempo-medio-detalhado/tempo-medio-detalhado.component';
import { TextDialogComponent } from './componentes/text-dialog/text-dialog.component';
import { UsuarioModule } from './componentes/usuario/usuario.module';
import { DndDirective } from './diretivas/dnd.directive';
import { PhoneMaskDirective } from './diretivas/phone-mask.directive';
import { InterceptorModule } from './interceptor/interceptor.module';
import { PortuguesDateAdapter } from './PortuguesDateAdapter';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    PhoneMaskDirective,
    DialogoComponent,
    FooterComponent,
    AgendaItemComponent,
    SideNavComponent,
    DndDirective,
    CancelamentoComponent,
    TextDialogComponent,
    ParametrosComponent,
    IapComponent,
    LogComponent,
    LogDetailComponent,
    TempoMedioDetalhadoComponent,
  ],
  imports: [
    InterceptorModule,
    HttpClientModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    LoginModule,
    HomeModule,
    UsuarioModule,
    CampanhaModule,
    CupomModule,
    AgenciaModule,
    MatNativeDateModule,
    MatListModule,
    MatSidenavModule,
    MatExpansionModule,
    NgxCurrencyDirective,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production, 
      registrationStrategy: 'registerWhenStable:30000'
    })
],
  exports: [
    MatSidenavModule,
    MatListModule,
    MatExpansionModule    
  ],
  providers: [
    DatePipe,
    {
      provide: DateAdapter, useClass: PortuguesDateAdapter,
    },
    {
      provide: LocationStrategy, useClass: HashLocationStrategy
    },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    provideEnvironmentNgxCurrency({
      align: "right",
      allowNegative: true,
      allowZero: true,
      decimal: ",",
      precision: 2,
      prefix: "R$ ",
      suffix: "",
      thousands: ".",
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Financial,
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
